import { Component, OnInit } from '@angular/core';
import { Footer } from './Footer';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import {Globals} from '../globals';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  footer: Footer;
  constructor(private http: HttpClient , private route: ActivatedRoute, public globals: Globals) { }


  ngOnInit() {
    this.http.get<Footer>(this.globals.urlMain +'footer').subscribe(data => {
      this.footer = data;


    });

  }

}
